import React, { useState, useEffect } from 'react'
import './Experiment.css'
import { whitespace, Query } from '../../helpers/whitespace'
import { CorporateLogo } from '../../components/CorporateLogo'
import { Modal, Col, Row, Button, Tab, Tabs, Form, Container } from 'react-bootstrap'

const Pill = ( { value } ) => {
    return ( <div className='Pill'>{value}</div> )
}
const PeopleList = ( props ) => {
    const people = [ 
        'Jonathan Clarke', 'Marcus Broome', 'Alex Mundy', 'Alex Baines', 
        'Alecsandria Missungu', 'Hussein Ali', 'David Harrison', 'Dave Pay', 'Jahangir Alom', 'Rohit Natarajan', 'Anne McKenna', 'Anna Farmer',
        'Jody Wilkinson'
    ]

    const [ filter, setFilter ] = useState( props.filter ) 
    // useEffect(() => {
    //     setFilter(props.filter)
    // }, [props.filter])

    const fix = ( itm ) => {
        return itm // .replace( ' ', '_' )
    }

    return (
        <>
        <div className='QuietBorder'>
        <h2>{people.length} People</h2>
        <div>
        { people.sort( ( x, y ) => { return x.localeCompare( y ) })
        .map( itm => { return <Pill value={itm}/> } ) }
        </div>
        <div className='ClearBoth'></div>
        <h2>Filter on {filter}</h2>
        <div>Favourite searches 
            &nbsp;<span className='MyLink' onClick={ () => setFilter( 'Dav') }>Dav</span>
            &nbsp;<span className='MyLink' onClick={ () => setFilter( 'Ann') }>Ann</span>
        </div>
        <input type='text' value={filter} onChange={(e) => setFilter(e.target.value)}/>
        <div className='Above12'>
        { people
            .filter( itm => itm.toLowerCase().includes( filter.toLowerCase() ) )
            .sort( ( x, y ) => { return x.localeCompare( y ) })
            .map( itm => { return <Pill value={itm}/> } ) }
        </div>
        <div className='ClearBoth'></div>
        </div>
        </>
    )
}

export const CorporateIcon = () => {
    return (
        <div className='QuietBorder'>
            <div className='Width100'>
                <CorporateLogo companyId='' />
            </div>
        </div>
    )
}

export const WarAndTerrorPortal = () => {
    return (
        <>
        <div>War and Terror Additional Input</div>
        <Container>
            <Row className='Above12'>
                <Col className='col-md-2'>Location</Col>
                <Col className='col-md-2'><input type='text' placeholder='Number and Street' value="2412 Main St" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='City' value="Des Moines" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='State' value="Iowa" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Zip Code' value="50301" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Country' value="United States"/></Col>
            </Row>
            <Row>
                <Col className='col-md-2'>Loss 1</Col>
                <Col className='col-md-2'><input type='text' placeholder='Date of Loss' value="13 May 2020" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Amount' value="USD 13,500" /></Col>
                <Col className='col-md-6'><span className='MyLink'>Remove</span></Col>
            </Row>
            <Row>
                <Col className='col-md-2'>Loss 2</Col>
                <Col className='col-md-2'><input type='text' placeholder='Date of Loss' value="5 October 2022"/></Col>
                <Col className='col-md-2'><input type='text' placeholder='Amount' value="USD 12,000"/></Col>
                <Col className='col-md-6'><span className='MyLink'>Remove</span> : <span className='MyLink'>Add Another Loss</span> </Col>
            </Row>
            <Row className='Above12'>
                <Col className='col-md-2'>Location</Col>
                <Col className='col-md-2'><input type='text' placeholder='Number and Street' value="1005 First Avenue" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='City' value="Des Moines" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='State' value="Iowa" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Zip Code' value="50301" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Country' value="United States"/></Col>
            </Row>
            <Row>
                <Col className='col-md-2'>Loss 1</Col>
                <Col className='col-md-2'><input type='text' placeholder='Date of Loss' value="13 May 2020" /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Amount' value="USD 9,500" /></Col>
                <Col className='col-md-6'><span className='MyLink'>Remove</span></Col>
            </Row>
            <Row>
                <Col className='col-md-2'>Loss 2</Col>
                <Col className='col-md-2'><input type='text' placeholder='Date of Loss' value="1 March 2023"/></Col>
                <Col className='col-md-2'><input type='text' placeholder='Amount' value="USD 21,000"/></Col>
                <Col className='col-md-6'><span className='MyLink'>Remove</span> : <span className='MyLink'>Add Another Loss</span> </Col>
            </Row>
            <Row className='Above12'>
                <Col className='col-md-2'>Location</Col>
                <Col className='col-md-2'><input type='text' placeholder='Number and Street' /></Col>
                <Col className='col-md-2'><input type='text' placeholder='City' /></Col>
                <Col className='col-md-2'><input type='text' placeholder='State' /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Zip Code' /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Country' /></Col>
            </Row>
            <Row>
                <Col className='col-md-2'>Loss 1</Col>
                <Col className='col-md-2'><input type='text' placeholder='Date of Loss' /></Col>
                <Col className='col-md-2'><input type='text' placeholder='Amount' /></Col>
                <Col className='col-md-6'><span className='MyLink'>Remove</span> : <span className='MyLink'>Add Another Loss</span> </Col>
            </Row>
            <Row>
            <Col className='col-md-6'><span className='MyLink'>Add Another Location</span> </Col>
            </Row>

        </Container>
        <div className='Above12'>&nbsp;</div>
        </>
    )
}

export const Experiment = () => {


    return (
        <>
        <WarAndTerrorPortal />
        <CorporateIcon />
        <PeopleList filter={'al'}/>
        </>
    )
}